// Add your custom JS here.


// Force FacetWP to use a specific URL for AJAX
document.addEventListener('facetwp-loaded', function() {
    FWP.hooks.addFilter('facetwp/ajaxurl', function(url) {
        return 'https://catalunyapaisdarxius.cat/wp-json/facetwp/v1/refresh';
    });
});


document.addEventListener('facetwp-refresh', function() {
    FWP.hooks.addFilter('facetwp/ajaxurl', function(url) {
        return 'https://catalunyapaisdarxius.cat/wp-json/facetwp/v1/refresh';
    });
});


function getColor(i) {
  // 40% de probabilitat blanc, 60% repartit entre la resta
  if (Math.random() < 0.4) {
    return "#FAF9F7"; // blanc
  } else {
    const others = ["#8BA966", "#EB7F76", "#FCF099", "#ACC5DD", "#F5BC2E"];
    return others[i % others.length];
  }
}

const colors = ['#b7cee3', '#f8f191', '#8aa36e', '#ffffff', '#f0b429', '#e37870'];
const wrapper = document.querySelector('.entry-header');
const bg = wrapper.querySelector('.title-background');
const text = wrapper.querySelector('.entry-title');

// Esperem que la font carregui i mesurem amplada
window.addEventListener('load', () => {
	const blockWidth = 40; // amplada de cada bloc
	const totalWidth = text.offsetWidth;
	const blockCount = Math.ceil(totalWidth / blockWidth);
/*
if (bg) {
    bg.innerHTML = ''; // netegem
    for (let i = 0; i < blockCount; i++) {
        const block = document.createElement('div');
        block.classList.add('color-block');
        block.style.backgroundColor = colors[i % colors.length];

        // Desplaçament vertical aleatori entre -5 i +5 píxels
        const offset = Math.floor(Math.random() * 11) - 5; // valors de -5 a +5
        block.style.marginTop = `${offset}px`;

        bg.appendChild(block);

        // Animate with a staggered delay
        setTimeout(() => {
            block.classList.add('visible');
        }, 80 * i);
    }
}
    */

/*
		const titleEl = document.getElementById("my-title");
		const text2 = titleEl.innerText;
		titleEl.innerHTML = ""; // netegem el contingut

		console.log("ccc", text2);
		
		[...text2].forEach((char, index) => {
			const span = document.createElement("span");
			span.textContent = char;
			span.style.backgroundColor = colors[index % colors.length];
			titleEl.appendChild(span);
		});
        */

  const titleEl = document.getElementsByClassName("entry-title")[0];
  const text2 = titleEl.textContent.trim();
  titleEl.textContent = ""; // netegem el contingut original


  text2.split(" ").forEach((word, wi) => {
  const wordSpan = document.createElement("span");
  wordSpan.style.whiteSpace = "nowrap"; // evita trencar la paraula

  [...word].forEach((char, i) => {
    const span = document.createElement("span");
    span.textContent = char;
    span.classList.add("letter");
    //span.style.backgroundColor = getColor(i);
     span.style.backgroundColor = colors[(wi * word.length + i) % colors.length];
    wordSpan.appendChild(span);
  });

  titleEl.appendChild(wordSpan);

  
  // afegir un "espai" com a lletra amb color
  if(wi < text2.split(" ").length - 1) {

    const spaceSpan = document.createElement("span");
    spaceSpan.textContent = " ";
    spaceSpan.classList.add("letter");
    //spaceSpan.style.backgroundColor = getColor(0);
    spaceSpan.style.backgroundColor = colors[(wi * word.length + word.length + 2) % colors.length];
    titleEl.appendChild(spaceSpan);
  }


});

  // Crear spans per cada lletra
  /*
  [...text2].forEach((char, i) => {
    const span = document.createElement("span");
    span.textContent = char;
    span.classList.add("letter");
    span.style.backgroundColor = colors[i % colors.length];
    titleEl.appendChild(span);
  });
  */

  // Animació: cada lletra cau i després es desplaça aleatòriament cap amunt o avall
  gsap.from(".letter", {
    y: -200,
    opacity: 0,
    duration: 0.6,
    stagger: 0.1,
    ease: "power3.out",
    onComplete: () => {
      document.querySelectorAll(".letter").forEach((el, i) => {
        const randomY = Math.floor(Math.random() * 11); // valor entre -20 i +20
        gsap.to(el, {
          y: randomY,
          duration: 0.5,
          ease: "power2.out",
          delay: i * 0.05
        });
      });
    }
  });


});


